module.exports = require("string_decoder");


//////////////////
// WEBPACK FOOTER
// external "string_decoder"
// module id = 270
// module chunks = 0 1